<div role="rowgroup" class="border-default border-b">
  <div
    [style]="tableColumnStyles()"
    role="row"
    cdkDropList
    (cdkDropListDropped)="onDrop($event)"
    cdkDropListOrientation="horizontal"
    class="group/row">
    @if (config().rowNumbers) {
      <div
        role="columnheader"
        class="table-frozen-cell bg-elevated text-text-secondary text-2xs flex items-center justify-center p-2 font-medium">
        #
      </div>
    }

    @if (config().selection?.enabled && config().selection?.mode === 'checkbox') {
      <div
        role="columnheader"
        class="table-frozen-cell bg-elevated flex justify-center"
        (keydown.enter)="toggleSelection()()"
        (click)="toggleSelection()()">
        @if (config().selection?.multiple) {
          <app-checkbox
            class="flex"
            size="sm"
            [checked]="isAllRowSelected()"
            [indeterminate]="isAnySelectedRow() && !isAllRowSelected()" />
        }
      </div>
    }

    @for (column of columns(); track column.key) {
      <div
        #header
        cdkDrag
        [cdkDragDisabled]="!isColumnMovable(column)"
        role="columnheader"
        [resizingDisabled]="!isColumnResizeable(column)"
        appColumnResizer
        [minWidth]="80"
        [columnKey]="String(column.key)"
        (columnResize)="onColumnResize($event)"
        [class]="isColumnMovable(column) ? 'cursor-move' : ''"
        class="group text-text-secondary text-2xs relative px-2.5 py-1.5 text-left">
        <div class="flex h-full w-full items-center justify-between">
          <span class="truncate font-medium">
            {{ column.label }}
          </span>

          <app-tooltip
            [target]="header"
            [content]="
              config().columnTooltips ? (column.tooltip ?? column.label) : column.label
            "
            [position]="'top-start'" />

          @if (columnHasActions()) {
            <div class="flex items-center gap-1">
              <div class="flex items-center gap-0.5">
                @if (column.sortDirection; as direction) {
                  <button
                    class="btn-transparent flex h-full w-full items-center justify-center rounded-md p-1 text-xs font-medium"
                    (click)="removeSort()(column)">
                    @if (direction === 'asc') {
                      <i [class]="ICONS.sortAscending" class="text-text-tertiary"></i>
                    } @else {
                      <i [class]="ICONS.sortDescending" class="text-text-tertiary"></i>
                    }
                  </button>
                }

                @if (columnIsFiltered(column)) {
                  <button
                    class="btn-transparent flex h-full w-full items-center justify-center rounded-md p-1 text-xs font-medium"
                    (click)="clearColumnFilter(column)">
                    <i [class]="ICONS.funnel" class="text-text-tertiary"></i>
                  </button>
                }
              </div>

              @if (columnActions(column).length > 0) {
                <button
                  [appDropdown]="tableHeaderActionDropdown"
                  [dropdownContext]="{ actions: columnActions(column) }"
                  [dropdownTrigger]="['click']"
                  aria-haspopup="true"
                  class="btn-transparent flex h-full w-full items-center justify-center rounded-md p-1 text-xs font-medium opacity-0 transition-opacity group-hover/row:opacity-100 focus-visible:opacity-100"
                  type="button">
                  <i [class]="ICONS.dotsThreeHorizontal" class="text-text-tertiary"></i>
                </button>
              }
            </div>
          }
        </div>

        @if (config().columnColors && column.color) {
          <div
            class="absolute bottom-0 h-1 rounded-full shadow-sm"
            [style.width]="column.width ? column.width - 16 + 'px' : '104px'"
            [style.background]="column.color"></div>
        }
      </div>
    }

    @if (hasActions()) {
      <div role="columnheader"></div>
    }

    @if (config().columnActionSettings?.hideable && hiddenColumns().length > 0) {
      <div class="text-text-secondary flex items-center justify-center" role="columnheader">
        <button
          #hiddenColumnsTrigger
          (click)="toggleHiddenColumnsDropdown()"
          [attr.aria-expanded]="isHiddenColumnsDropdownOpen()"
          aria-haspopup="true"
          class="btn-transparent hover:bg-interactive flex cursor-pointer items-center justify-center rounded-md p-2 text-xs font-medium"
          type="button">
          <i [class]="ICONS.plus"></i>
        </button>

        <app-dropdown
          [target]="hiddenColumnsTrigger"
          [template]="hiddenColumnsDropdownContent"
          [isOpen]="isHiddenColumnsDropdownOpen()"
          [onClose]="onCloseHiddenColumnsDropdown"
          [closeOnClickOutside]="true"
          [closeOnEscape]="true" />
      </div>
    }
  </div>
</div>

<ng-template #tableHeaderActionDropdown let-actions="actions">
  <app-items-dropdown [items]="actions" />
</ng-template>

<ng-template #hiddenColumnsDropdownContent>
  <app-items-dropdown [items]="hiddenColumns()" />
</ng-template>
